import { Link, useLocation } from "wouter";
import { Inbox, Library, Search, MessagesSquare } from "lucide-react";
import { cn } from "@/lib/utils";

const TABS = [
  { to: "/inbox", label: "Inbox", icon: Inbox },
  { to: "/biblioteca", label: "Biblioteca", icon: Library },
  { to: "/buscar", label: "Buscar", icon: Search },
  { to: "/asistente", label: "Asistente", icon: MessagesSquare },
];

export const BottomTabs = () => {
  const [location] = useLocation();
  return (
    <nav
      className="md:hidden fixed bottom-0 inset-x-0 z-40 border-t bg-background/95 backdrop-blur grid grid-cols-4 h-16"
      aria-label="Navegación móvil"
      data-testid="bottom-tabs"
    >
      {TABS.map(({ to, label, icon: Icon }) => {
        const active = location.startsWith(to);
        return (
          <Link
            key={to}
            href={to}
            data-testid={`tab-${to.slice(1)}`}
            className={cn(
              "flex flex-col items-center justify-center gap-1 text-[11px] font-medium transition-colors",
              active ? "text-primary" : "text-muted-foreground",
            )}
          >
            <Icon className="h-5 w-5" strokeWidth={active ? 2 : 1.75} />
            {label}
          </Link>
        );
      })}
    </nav>
  );
};
